import React, { useEffect, useState } from 'react';
import { cubicBezierEasingFn } from '@shared/utils/animationTransition';
import { useSpring } from 'react-spring';
import { StyledTransitionWrapper } from '@apps/guest/packages/layout-engine/components/ActionBar/ActionBar.styles';

export interface PreviewFadeTransition {
  show: boolean;
}

export const ActionBarTransition: React.FC<PreviewFadeTransition> = ({ children, show }) => {
  // State to control when to remove display: none
  // Initially visible if show is true
  const [isVisible, setIsVisible] = useState(show);

  // When show becomes true, immediately set isVisible to true
  // so the spring animation can play
  useEffect(() => {
    if (show) setIsVisible(true);
  }, [show]);

  // Animate opacity and offset with react-spring
  // onRest callback sets isVisible to false after fade-out completes
  const springProps = useSpring({
    opacity: show ? 1 : 0,
    offset: show ? 0 : -40,
    config: {
      duration: 500,
      easing: cubicBezierEasingFn,
    },
    onRest: () => {
      // After fade-out, hide the element with display: none
      if (!show) setIsVisible(false);
    },
  });

  return (
    <StyledTransitionWrapper
      style={{
        // Animate opacity and vertical offset
        opacity: springProps.opacity,
        transform: springProps.offset.interpolate(x => `translate3d(0, ${x}px, 0)`),
        // Only render the element when visible or animating
        display: isVisible ? '' : 'none',
      }}
    >
      {children}
    </StyledTransitionWrapper>
  );
};
